/* PlanetMist light theme: contrast repair for review apps.
   The apps were configured for a dark page, so some of their text is still
   light-on-light. This finds text whose colour is close to the surface it sits
   on and flips it, in either direction, without touching anything that already
   reads. */
(function () {
  'use strict';

  function luminance(colour) {
    var m = /rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,\s\/]+([\d.]+))?\)/.exec(colour || '');
    if (!m) return null;
    if (m[4] !== undefined && parseFloat(m[4]) < 0.5) return null;
    return (0.299 * +m[1] + 0.587 * +m[2] + 0.114 * +m[3]) / 255;
  }

  function isAppNode(el) {
    var tag = (el.tagName || '').toLowerCase();
    if (tag.indexOf('quoli') === 0 || tag.indexOf('jdgm') === 0 || tag.indexOf('judgeme') === 0) return true;
    var cls = typeof el.className === 'string' ? el.className : '';
    return /quoli|jdgm|judgeme/i.test(cls) || /quoli|jdgm|judgeme/i.test(el.id || '');
  }

  function groundUnder(el) {
    for (var node = el; node && node.nodeType === 1; node = node.parentElement) {
      var l = luminance(getComputedStyle(node).backgroundColor);
      if (l !== null) return l;
    }
    return 0.95;
  }

  function holdsText(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) return true;
    }
    return false;
  }

  var SHADOW_RULES =
    '.pm-app-ink, .pm-app-ink * { color: #1b1411 !important; }' +
    '.pm-app-paper, .pm-app-paper * { color: #f2eadf !important; }';

  function repairWithin(root, depth) {
    if (!root || depth > 4) return;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.shadowRoot) {
        if (!el.shadowRoot.querySelector('style[data-pm-ink]')) {
          var style = document.createElement('style');
          style.setAttribute('data-pm-ink', '');
          style.textContent = SHADOW_RULES;
          el.shadowRoot.appendChild(style);
        }
        repairWithin(el.shadowRoot, depth + 1);
      }
      if (!el.classList || el.classList.contains('pm-app-ink') || el.classList.contains('pm-app-paper')) continue;
      if (!holdsText(el)) continue;
      var textLuminance = luminance(getComputedStyle(el).color);
      if (textLuminance === null) continue;
      var ground = groundUnder(el);
      if (ground > 0.6 && textLuminance > 0.55) el.classList.add('pm-app-ink');
      else if (ground < 0.35 && textLuminance < 0.45) el.classList.add('pm-app-paper');
    }
  }

  function repair() {
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      var nodes = section.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!isAppNode(el)) continue;
        if (el.closest('product-info, .product__info-container')) continue;
        var outermost = true;
        for (var p = el.parentElement; p && p !== section; p = p.parentElement) {
          if (isAppNode(p)) { outermost = false; break; }
        }
        if (outermost) repairWithin(el, 0);
      }
    });
  }

  function schedule() {
    if (window.requestAnimationFrame) requestAnimationFrame(repair);
    else repair();
  }

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  [600, 1500, 3000].forEach(function (delay) { setTimeout(schedule, delay); });
  if ('MutationObserver' in window) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(schedule, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
